// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stato-card {
  overflow: visible;
  border-left: 4px solid #d1d5db;
  transition: border-color 0.3s ease;
}
.stato-card.stato-ok {
  border-left-color: var(--ion-color-success);
}
.stato-card.stato-ko {
  border-left-color: var(--ion-color-danger);
}

:host-context(.dark) .stato-card {
  border-left-color: #4b5563;
}
:host-context(.dark) .stato-card.stato-ok {
  border-left-color: var(--ion-color-success);
}
:host-context(.dark) .stato-card.stato-ko {
  border-left-color: var(--ion-color-danger);
}

.inviata-block {
  position: relative;
  background-color: #efefef;
  color: var(--ion-text-color, #1f2937);
  border: 1px solid #d1d5db;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.inviata-block:hover:not(.is-loading) {
  background-color: #d1d5db;
}
.inviata-block:hover:not(.is-loading) .inviata-tooltip {
  opacity: 1;
  visibility: visible;
}
.inviata-block.is-loading {
  cursor: not-allowed;
  pointer-events: none;
}
.inviata-block.inviata-ko {
  background-color: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
}

.inviata-tooltip {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  max-width: 280px;
  z-index: 100;
  background: var(--notifications-surface);
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}
.inviata-tooltip__title {
  font-size: 0.78rem;
  font-weight: 600;
  color: #ef4444;
  margin: 0 0 6px;
}
.inviata-tooltip__values {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.75rem;
  color: var(--ion-color-medium, #92949c);
  margin-bottom: 8px;
}
.inviata-tooltip__hint {
  font-size: 0.73rem;
  color: var(--ion-text-color, #fff);
  margin: 0 0 4px;
}
.inviata-tooltip__sub {
  font-size: 0.7rem;
  color: var(--ion-color-medium, #92949c);
  margin: 0;
}

.inviata-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  z-index: 10;
}

:host-context(.dark) .inviata-loading-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

:host-context(.dark) .inviata-block {
  background-color: #374151;
  border: 1px solid #4b5563;
}

:host-context(.dark) .inviata-block.inviata-ko {
  background-color: rgba(239, 68, 68, 0.25);
  border-color: rgba(239, 68, 68, 0.6);
}

:host-context(.dark) .inviata-block:hover:not(.is-loading) {
  background-color: #4b5563;
}

@media (max-width: 1023.98px) {
  :host {
    display: block;
  }
  .imoi-primary-row,
  .imoi-progress-row {
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    align-items: stretch !important;
    gap: 0.45rem;
    padding: 0 !important;
  }
  .imoi-progress-row {
    margin-top: 0.45rem;
  }
  .imoi-card {
    width: 100% !important;
    min-width: 0;
    height: 100%;
    margin: 0 !important;
    border-radius: 0.85rem;
  }
  .imoi-grid {
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr));
    align-items: stretch;
    gap: 0.4rem;
    height: 100%;
    padding: 0.45rem;
  }
  .imoi-grid > div {
    min-width: 0;
    padding: 0.55rem !important;
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 0.65rem;
    background: rgba(148, 163, 184, 0.1);
  }
  .imoi-grid > :last-child:nth-child(odd) {
    grid-column: 1/-1;
  }
  .imoi-article-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .imoi-grid ion-card-subtitle {
    margin-bottom: 0.2rem;
    font-size: 0.72rem;
    letter-spacing: 0.02em;
  }
  .imoi-grid ion-card-title,
  .imoi-progress-card ion-card-title {
    min-width: 0;
    font-size: 1.12rem;
    line-height: 1.18;
    word-break: break-word;
  }
  .imoi-grid .text-4xl {
    font-size: 1.7rem;
  }
  .imoi-grid .text-2xl,
  .imoi-progress-card .text-2xl {
    font-size: 1.28rem;
  }
  .imoi-grid .text-xl {
    font-size: 1.05rem;
  }
  .imoi-progress-card {
    display: flex;
    align-items: stretch;
  }
  .imoi-progress-card > div {
    width: 100%;
    padding: 0.75rem !important;
  }
  .inviata-tooltip {
    left: 50%;
    width: min(17.5rem, 100vw - 3rem);
    min-width: 0;
    transform: translateX(-50%);
  }
  :host-context(.dark) .imoi-grid > div {
    background: rgba(15, 23, 42, 0.28);
  }
  .ordine-storia-icon {
    transform: scale(1.25);
    transform-origin: center;
  }
}
.stato-wait-pulse {
  animation: wait-pulse 1.5s ease-in-out infinite;
}

@keyframes wait-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ordine-info/ordine-info.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,8BAAA;EACA,kCAAA;AACF;AACE;EACE,2CAAA;AACJ;AAEE;EACE,0CAAA;AAAJ;;AAIA;EACE,0BAAA;AADF;AAGE;EACE,2CAAA;AADJ;AAIE;EACE,0CAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAKI;EACE,UAAA;EACA,mBAAA;AAHN;AAOE;EACE,mBAAA;EACA,oBAAA;AALJ;AAQE;EACE,wCAAA;EACA,oCAAA;AANJ;;AAUA;EACE,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;EAEA,kBAAA;EACA,wBAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EAEA,wCAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AATF;AAWE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,kCAAA;EACA,eAAA;AAXJ;AAcE;EACE,iBAAA;EACA,uCAAA;EACA,SAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,oCAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,yCAAA;EACA,oCAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE;IACE,cAAA;EAbF;EAgBA;;IAEE,wBAAA;IACA,2DAAA;IACA,+BAAA;IACA,YAAA;IACA,qBAAA;EAdF;EAiBA;IACE,mBAAA;EAfF;EAkBA;IACE,sBAAA;IACA,YAAA;IACA,YAAA;IACA,oBAAA;IACA,sBAAA;EAhBF;EAmBA;IACE,wBAAA;IACA,4DAAA;IACA,oBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;EAjBF;EAoBA;IACE,YAAA;IACA,2BAAA;IACA,2CAAA;IACA,sBAAA;IACA,oCAAA;EAlBF;EAqBA;IACE,iBAAA;EAnBF;EAsBA;IACE,qCAAA;EApBF;EAuBA;IACE,qBAAA;IACA,kBAAA;IACA,sBAAA;EArBF;EAwBA;;IAEE,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,sBAAA;EAtBF;EAyBA;IACE,iBAAA;EAvBF;EA0BA;;IAEE,kBAAA;EAxBF;EA2BA;IACE,kBAAA;EAzBF;EA4BA;IACE,aAAA;IACA,oBAAA;EA1BF;EA6BA;IACE,WAAA;IACA,2BAAA;EA3BF;EA8BA;IACE,SAAA;IACA,iCAAA;IACA,YAAA;IACA,2BAAA;EA5BF;EA+BA;IACE,kCAAA;EA7BF;EAgCA;IACE,sBAAA;IACA,wBAAA;EA9BF;AACF;AAiCA;EACE,+CAAA;AA/BF;;AAkCA;EACE;IACE,UAAA;EA/BF;EAiCA;IACE,YAAA;EA/BF;AACF","sourcesContent":[".stato-card {\n  overflow: visible;\n  border-left: 4px solid #d1d5db;\n  transition: border-color 0.3s ease;\n\n  &.stato-ok {\n    border-left-color: var(--ion-color-success);\n  }\n\n  &.stato-ko {\n    border-left-color: var(--ion-color-danger);\n  }\n}\n\n:host-context(.dark) .stato-card {\n  border-left-color: #4b5563;\n\n  &.stato-ok {\n    border-left-color: var(--ion-color-success);\n  }\n\n  &.stato-ko {\n    border-left-color: var(--ion-color-danger);\n  }\n}\n\n.inviata-block {\n  position: relative;\n  background-color: #efefef;\n  color: var(--ion-text-color, #1f2937);\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n\n  &:hover:not(.is-loading) {\n    background-color: #d1d5db;\n\n    .inviata-tooltip {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  &.is-loading {\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n\n  &.inviata-ko {\n    background-color: rgba(239, 68, 68, 0.2);\n    border-color: rgba(239, 68, 68, 0.5);\n  }\n}\n\n.inviata-tooltip {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease;\n\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  min-width: 220px;\n  max-width: 280px;\n  z-index: 100;\n\n  background: var(--notifications-surface);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  border-radius: 8px;\n  padding: 10px 12px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n\n  &__title {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #ef4444;\n    margin: 0 0 6px;\n  }\n\n  &__values {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 0.75rem;\n    color: var(--ion-color-medium, #92949c);\n    margin-bottom: 8px;\n  }\n\n  &__hint {\n    font-size: 0.73rem;\n    color: var(--ion-text-color, #fff);\n    margin: 0 0 4px;\n  }\n\n  &__sub {\n    font-size: 0.7rem;\n    color: var(--ion-color-medium, #92949c);\n    margin: 0;\n  }\n}\n\n.inviata-loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  border-radius: 4px;\n  z-index: 10;\n}\n\n:host-context(.dark) .inviata-loading-overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n:host-context(.dark) .inviata-block {\n  background-color: #374151;\n  border: 1px solid #4b5563;\n}\n\n:host-context(.dark) .inviata-block.inviata-ko {\n  background-color: rgba(239, 68, 68, 0.25);\n  border-color: rgba(239, 68, 68, 0.6);\n}\n\n:host-context(.dark) .inviata-block:hover:not(.is-loading) {\n  background-color: #4b5563;\n}\n\n@media (max-width: 1023.98px) {\n  :host {\n    display: block;\n  }\n\n  .imoi-primary-row,\n  .imoi-progress-row {\n    display: grid !important;\n    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n    align-items: stretch !important;\n    gap: 0.45rem;\n    padding: 0 !important;\n  }\n\n  .imoi-progress-row {\n    margin-top: 0.45rem;\n  }\n\n  .imoi-card {\n    width: 100% !important;\n    min-width: 0;\n    height: 100%;\n    margin: 0 !important;\n    border-radius: 0.85rem;\n  }\n\n  .imoi-grid {\n    display: grid !important;\n    grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr));\n    align-items: stretch;\n    gap: 0.4rem;\n    height: 100%;\n    padding: 0.45rem;\n  }\n\n  .imoi-grid > div {\n    min-width: 0;\n    padding: 0.55rem !important;\n    border: 1px solid rgba(148, 163, 184, 0.35);\n    border-radius: 0.65rem;\n    background: rgba(148, 163, 184, 0.1);\n  }\n\n  .imoi-grid > :last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n  }\n\n  .imoi-article-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .imoi-grid ion-card-subtitle {\n    margin-bottom: 0.2rem;\n    font-size: 0.72rem;\n    letter-spacing: 0.02em;\n  }\n\n  .imoi-grid ion-card-title,\n  .imoi-progress-card ion-card-title {\n    min-width: 0;\n    font-size: 1.12rem;\n    line-height: 1.18;\n    word-break: break-word;\n  }\n\n  .imoi-grid .text-4xl {\n    font-size: 1.7rem;\n  }\n\n  .imoi-grid .text-2xl,\n  .imoi-progress-card .text-2xl {\n    font-size: 1.28rem;\n  }\n\n  .imoi-grid .text-xl {\n    font-size: 1.05rem;\n  }\n\n  .imoi-progress-card {\n    display: flex;\n    align-items: stretch;\n  }\n\n  .imoi-progress-card > div {\n    width: 100%;\n    padding: 0.75rem !important;\n  }\n\n  .inviata-tooltip {\n    left: 50%;\n    width: min(17.5rem, calc(100vw - 3rem));\n    min-width: 0;\n    transform: translateX(-50%);\n  }\n\n  :host-context(.dark) .imoi-grid > div {\n    background: rgba(15, 23, 42, 0.28);\n  }\n\n  .ordine-storia-icon {\n    transform: scale(1.25);\n    transform-origin: center;\n  }\n}\n\n.stato-wait-pulse {\n  animation: wait-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes wait-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
